(() => {
  class HomeCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
      if (!this.track || this.dots.length < 2) return;

      this.items = [...this.track.children];

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.items[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) this.mark(this.items.indexOf(entry.target));
          }
        },
        { root: this.track, threshold: 0.6 }
      );

      for (const item of this.items) this.observer.observe(item);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    mark(index) {
      if (index < 0) return;
      this.dots.forEach((dot, i) => {
        const current = i === index;
        dot.classList.toggle('bg-ink', current);
        dot.classList.toggle('bg-line', !current);
        dot.setAttribute('aria-current', current ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('home-carousel')) customElements.define('home-carousel', HomeCarousel);
})();
